import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { ItemCustomField } from '../../../types/custom_fields';

export type CustomFieldsState = {
  isFetching: boolean;
  customFields: ItemCustomField[];
};

const initalState: CustomFieldsState = {
  isFetching: true,
  customFields: [],
};

const reducer: Reducer<CustomFieldsState, FluxStandardAction> = (state = initalState, action) => {
  switch (action.type) {
    case 'FETCH_CUSTOM_FIELDS_PENDING': {
      return {
        ...state,
        isFetching: true,
      };
    }
    case 'FETCH_CUSTOM_FIELDS_FULFILLED': {
      return {
        ...state,
        isFetching: false,
        customFields: action.payload.data,
      };
    }
    case 'UPDATE_CUSTOM_FIELDS_FULFILLED': {
      const updatedFields = action.meta.customFields;

      // Create a map for quick lookup by brand_custom_field_id
      const updatedFieldsMap = new Map<number, ItemCustomField>();
      updatedFields.forEach((f: ItemCustomField) => {
        updatedFieldsMap.set(f.brand_custom_field_id, f);
      });

      // Create a map of existing state fields
      const stateFieldsMap = new Map<number, ItemCustomField>();
      state.customFields.forEach((field: ItemCustomField) => {
        stateFieldsMap.set(field.brand_custom_field_id, field);
      });

      // Update existing fields
      const updatedStateFields = state.customFields.map((field: ItemCustomField) => {
        const updatedField = updatedFieldsMap.get(field.brand_custom_field_id);
        if (updatedField) {
          // Update the value from the updated field
          return {
            ...field,
            value: updatedField.value,
          };
        }
        // Keep the field unchanged
        return field;
      });

      // Find new fields from updatedFields that don't exist in state
      const newFields = updatedFields.filter(
        (f: ItemCustomField) => !stateFieldsMap.has(f.brand_custom_field_id)
      );

      return {
        ...state,
        customFields: [...updatedStateFields, ...newFields],
      };
    }
  }
  return state;
};

export default reducer;
